import Axios from 'axios'
import { API_URL } from '@app/constants/endpoints'

const ENDPOINT = (id) => `${API_URL}/api/v6/user_requests/${id}/approve`

const approveUserRequest = (accessToken, id, data) => Axios.post(ENDPOINT(id), data, {
  headers: { 'Access-Token': accessToken },
})

export default {
  approveUserRequest,
}
